import { render, staticRenderFns } from "./asuransi.vue?vue&type=template&id=18cd4b07"
import script from "./asuransi.vue?vue&type=script&lang=js"
export * from "./asuransi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports